function Init({ children }) {
  return true && children;
}

export default Init;
